module.exports = __webpack_public_path__ + "img/ratatouille.dcfdd31b.jpg";